export default __webpack_public_path__ + "static/Main-img-e72d5f6966421967e1a59fcf2df8361c.jpg";